export default "__VITE_ASSET__c03a55dd__"